import React, { useMemo } from 'react';
import { useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { PdfTemplateContext } from '../../../context/PdfTemplateContext';
import { useToast } from '../../../providers/ToastProvider';
import { useRequest } from '../../../requests/common/requestHook';
import { PdfTemplateRequest } from '../../../requests/pdf.request';
import { PdfTemplate, PdfTemplateInput } from '../../../types/pdf_template';
import { TranslationKey } from '../../../types/translation/TranslationKey';
import { translate } from '../../../types/translation/Translator';
import { ToastType } from '../../components/Toast';
import PdfTemplateEditor from './PdfTemplateEditor';

export default function UpdatePdfTemplateScreen() {
  const navigate = useNavigate();
  const id = useParams()['id'] || '';

  const { showToast } = useToast();

  const { pdfTemplates, setPdfTemplates, pdfTemplatesLoading } = useContext(PdfTemplateContext);
  const template = useMemo(() => pdfTemplates.get(id), [pdfTemplates, id]);

  const [update, { loading }] = useRequest(PdfTemplateRequest.update);

  const handleUpdate = async (template: PdfTemplateInput) => {
    const result = await update({ data: [new PdfTemplateInput(template).forUpdate()] });
    if (!result) return;

    result.forEach(updated => {
      const instance = new PdfTemplate(updated);
      console.log(instance);
      pdfTemplates.set(updated.id, instance);
    });
    setPdfTemplates(new Map(pdfTemplates));
    showToast({
      type: ToastType.success,
      title: translate({ key: TranslationKey.pdfTemplateUpdatedSuccessfullyToastTitle }),
    });
  };

  // TODO: handle not found
  if (!template) {
    return <div>Template not found</div>;
  }

  if (pdfTemplatesLoading) return <></>;

  return <PdfTemplateEditor template={template} onDone={template => handleUpdate(template)} />;
}
